import { render, staticRenderFns } from "./FloatingLayers.vue?vue&type=template&id=7b21d5f4&scoped=true&"
import script from "./FloatingLayers.vue?vue&type=script&lang=js&"
export * from "./FloatingLayers.vue?vue&type=script&lang=js&"
import style0 from "./FloatingLayers.vue?vue&type=style&index=0&id=7b21d5f4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b21d5f4",
  null
  
)

export default component.exports